import { ILayer } from '../../../types/common';

const source = 'highlights';

const config = {
  id: source,
  type: 'fill',
  source,
  layout: {
    visibility: 'visible',
  },
  paint: {
    'fill-color': '#6e599f',
    'fill-opacity': 0.3,
    'fill-outline-color': '#6e599f',
  },
};

const load = (): ILayer => {
  return {
    data: null,
    config,
    source,
    labels: null,
    markers: null,
  };
};

export default load;
